import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const ShipmentDistanceCellDisplay = ({ value }: { value: any }) => {
  const { t } = useTranslation('@cibo/landmanager/ShipmentDistance')
  if (value == null) return null
  const distance = value?.result ?? value?.input
  return (
    <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {distance} {t('miles')}
    </Typography>
  )
}

export const ShipmentDistanceCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const detail = params.row.findDetail({ traitId, year })
  return <ShipmentDistanceCellDisplay value={detail} />
}
